export const businessLabels = Object.freeze({
    orderStatus: Object.freeze({
        CREATED: '待支付',
        PENDING_PAYMENT: '待支付',
        PAYMENT_PENDING: '支付中',
        PAID_NEED_TRIP_INFO: '已支付待补资料',
        PAID_INFO_READY: '已支付资料齐全',
        PENDING_CONFIRM: '待运营确认',
        CONFIRMED: '已确认',
        PENDING_FULFILLMENT: '待履约准备',
        FULFILLMENT_READY: '履约已就绪',
        IN_SERVICE: '服务进行中',
        COMPLETED: '已完成',
        CANCELLED: '已取消',
        REFUND_APPLIED: '退款已申请',
        REFUND_PROCESSING: '退款处理中',
        REFUNDED: '已退款',
        AFTER_SALES: '售后处理中',
        AFTER_SALES_CLOSED: '售后已关闭',
    }),
});
//# sourceMappingURL=business-labels.js.map